/** Convenția modelelor 3D (aceeași cu scriptul Blender), plus conversia axelor Blender → glTF. */
import conventionJson from '../../data/schema/car-model-convention.json';
import type { VehicleDefinition } from '../data/types';

export interface PartRule {
  name: string;
  required: boolean | string;
  pivot: string;
  desc?: string;
  anim?: { axis: 'X' | 'Y' | 'Z'; openDeg?: number; travelDeg?: number };
}

export interface Convention {
  toleranceMm: number;
  maxMaterials: number;
  budgets: Record<'mobile' | 'desktop', { exterior: [number, number]; interior: [number, number]; engine: [number, number]; textureMax: number; maxDrawCalls: number }>;
  lods: Array<{ name: string; ratio: number }>;
  parts: PartRule[];
  lightMaterials: Record<string, string>;
}

export const CONVENTION = conventionJson as unknown as Convention;
export const PARTS = new Map(CONVENTION.parts.map((p) => [p.name, p]));

export function isRequired(rule: PartRule, v: VehicleDefinition): boolean {
  const c = rule.required;
  if (typeof c === 'boolean') return c;
  if (c.startsWith('doors>=')) return v.body.doors >= Number(c.slice(7));
  if (c.startsWith('body!=')) return v.body.type !== c.slice(6);
  if (c.startsWith('body=')) return v.body.type === c.slice(5);
  if (c.startsWith('gearbox=')) return v.transmission.type === c.slice(8);
  return false;
}

/** Axa din proprietățile Blender, exprimată în spațiul glTF (Y sus, Z înainte). */
export function blenderAxis(axis: string): [number, number, number] {
  switch (axis) {
    case 'X':
      return [1, 0, 0];
    case 'Y':
      return [0, 0, -1];
    default:
      return [0, 1, 0];
  }
}
